// extracted by mini-css-extract-plugin
export default {"pageLoading":"PageLoading_pageLoading__Fm2J5","spinnerBorder":"PageLoading_spinnerBorder__MaCMz","spinner-border":"PageLoading_spinner-border__JgStn"};